import { render, staticRenderFns } from "./AreaPageHeader.vue?vue&type=template&id=4099771a"
import script from "./AreaPageHeader.vue?vue&type=script&lang=js"
export * from "./AreaPageHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports